import { createFeature } from '@ngrx/store';
import { formsReducer } from './forms-reducer';

export const formsFeature = createFeature(
  {
    name: 'Forms',
    reducer: formsReducer
  }
)
